import React from 'react';
import { css } from '@emotion/react';
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import OptionFilter from '../modals/OptionFilter';
import { summarizeAssignments } from '../utils';
import { EmptyState, HeaderCell, Skipped, TableCard, TableFooter, TableScroll } from './blocks';
import { SHIPPER_COLUMNS } from './constants';
import ShipperRow from './ShipperRow';
import { pluralize } from './utils';

const ShippersTable = ({
    clients,
    assignmentsByShipper,
    assignmentsUnavailable,
    statusFilters,
    setFilter,
    onOpen,
    onDetails,
    onSignIn,
    onRoutingChange,
    isRoutingUpdating,
}) => (
    <TableCard>
        <TableScroll>
            <Table
                stickyHeader
                css={css`
                    table-layout: fixed;
                    width: 100%;
                `}
            >
                <TableHead>
                    <TableRow>
                        {SHIPPER_COLUMNS.map(({ key, label, width, align, filter }) => (
                            <HeaderCell
                                key={key}
                                align={align}
                                css={
                                    width
                                        ? css`
                                              width: ${width}px;
                                          `
                                        : undefined
                                }
                            >
                                <span
                                    css={css`
                                        align-items: center;
                                        display: inline-flex;
                                        gap: 2px;
                                    `}
                                >
                                    {label}
                                    {filter && (
                                        <OptionFilter
                                            value={statusFilters[filter.key] || null}
                                            onChange={(value) => setFilter(filter.key, value)}
                                            options={filter.options}
                                        />
                                    )}
                                </span>
                            </HeaderCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {clients.map((client) => (
                        <ShipperRow
                            key={client.client_id}
                            client={client}
                            assignment={summarizeAssignments(assignmentsByShipper?.[client.client_id])}
                            assignmentUnavailable={assignmentsUnavailable}
                            onOpen={() => onOpen(client)}
                            onDetails={() => onDetails(client)}
                            onSignIn={() => onSignIn(client)}
                            onRoutingChange={(next) => onRoutingChange(client, next)}
                            routingDisabled={isRoutingUpdating(client.client_id)}
                        />
                    ))}
                </TableBody>
            </Table>
            {clients.length === 0 && <EmptyState>No shippers match the current filters.</EmptyState>}
        </TableScroll>
        <TableFooter>
            <span>
                Showing {clients.length} {pluralize(clients.length, 'shipper')}
            </span>
            <Skipped />
        </TableFooter>
    </TableCard>
);

export default ShippersTable;
